import { render, staticRenderFns } from "./GlobalDropdown.vue?vue&type=template&id=388e980e&scoped=true&"
import script from "./GlobalDropdown.vue?vue&type=script&lang=js&"
export * from "./GlobalDropdown.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDropdown.vue?vue&type=style&index=0&id=388e980e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e980e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388e980e')) {
      api.createRecord('388e980e', component.options)
    } else {
      api.reload('388e980e', component.options)
    }
    module.hot.accept("./GlobalDropdown.vue?vue&type=template&id=388e980e&scoped=true&", function () {
      api.rerender('388e980e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/GlobalDropdown.vue"
export default component.exports